import React from 'react';
import Logo from './Logo';
import { Box, Container, Group } from '@mantine/core';
import { Profile } from './Profile';
import { AppMenu } from './Menu';

export function MegaHeader({ opened, toggle }: any) {
    return (
        <Box>
            <Container size={'100%'}>
                <Group justify="space-between" h="100%" wrap='nowrap'>
                    {/* <Burger
                        opened={opened}
                        onClick={toggle}
                        hiddenFrom="sm"
                        size="sm"
                    /> */}
                    <Logo />
                    <Group>
                        <AppMenu />
                        {/* <LangSwitcher /> */}
                        <Profile />
                        {/* <ThemeSwitcher /> */}
                    </Group>
                </Group>
            </Container>
        </Box>
    );
}